import React, { memo } from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Ahora abro el freezer y ya tengo opciones listas. Me bajó muchísimo el estrés.',
    name: 'Valeria M.',
    role: 'Mamá de 2'
  }, {
    text: 'Dejé de gastar tanto en delivery porque empecé a organizarme mejor.',
    name: 'Romina G.',
    role: 'Profesional independiente'
  }, {
    text: 'No necesitaba más tiempo para cocinar. Necesitaba un sistema.',
    name: 'Luciana P.',
    role: 'Empleada full-time'
  }, {
    text: 'Trabajo todo el día y esto me salvó las cenas. Llego y en 10 minutos comemos sano.',
    name: 'Daniela S.',
    role: 'Contadora'
  }, {
    text: 'Mis hijos aman las viandas y yo amo no tener que pensar qué mandarles cada mañana.',
    name: 'Carolina T.',
    role: 'Docente y mamá'
  }];
  return <section className="w-full bg-cream py-16 px-4 flex flex-col items-center" data-id="element-198">
      <div className="max-w-5xl w-full" data-id="element-199">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-12 text-center" data-id="element-200">
          💬 LO QUE DICEN OTRAS MUJERES
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-201">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-sage relative" data-id="element-202">
              <Quote className="absolute top-4 right-4 text-sage opacity-50" size={40} data-id="element-203" />
              <div className="flex gap-1 mb-4" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="text-gold-400 fill-current" size={16} data-id="element-205" />)}
              </div>
              <p className="text-brown-800 font-medium text-lg mb-6 italic relative z-10" data-id="element-206">
                "{testimonial.text}"
              </p>
              <div data-id="element-207">
                <p className="font-bold text-brown-800" data-id="element-208">{testimonial.name}</p>
                <p className="text-brown-600 text-sm" data-id="element-209">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}